/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     模型数据管理
  +--------------------------------------------------------------------------------------
*/
import Vue from 'vue'
import { getAllDevApi } from '@/api/dev/devApi'
import { getAllMappingApi } from '@/api/dev/devMappingApi'
import { getAllIconApi } from '@/api/dev/devIconApi'

const devStore = {
  state: {
    devsArr: [],
    mappingsArr: [],
    iconsArr: [],
    functionCodeArr: [
      { value: 1, title: 'F01 位 00001-09999 读线圈状态' },
      { value: 2, title: 'F02 位 10001-19999 读开关状态' },
      { value: 3, title: 'F03 字 40001-49999 读保持寄存器' },
      { value: 4, title: 'F04 字 30001-39999 读输入寄存器' },
      { value: 5, title: 'F05 位 写' },
      { value: 6, title: 'F06 字 写' }
    ],
    sensorAccessArr: [
      { value: 'R', title: '只读' },
      { value: 'W', title: '只写' },
      { value: 'RW', title: '读写' }
    ],
    sensorTypeArr: [
      { value: 1, title: '数值型' },
      { value: 2, title: '档位型' },
      { value: 3, title: '开关型' }
      // { value: 4, title: '定位型' }
    ],
    demicalArr: [
      { value: 0, title: '0位小数' },
      { value: 1, title: '1位小数' },
      { value: 2, title: '2位小数' },
      { value: 3, title: '3位小数' }
    ],
    dataFormatArr: [
      { value: 1, title: '16位有符号' },
      { value: 2, title: '16位无符号' },
      { value: 3, title: '16位按位取' },
      { value: 4, title: '32位有符号' },
      { value: 5, title: '32位无符号' },
      { value: 6, title: '32位浮点数' }
    ],
    byteOrderArr: [
      { value: 'ABCD', title: 'ABCD' },
      { value: 'CDAB', title: 'CDAB' },
      { value: 'BADC', title: 'BADC' },
      { value: 'DCBA', title: 'DCBA' }
    ],
    triggerEventArr: [
      { value: 1, title: '告警' },
      { value: 2, title: '开关机' }
    ],
    triggerTypeArr: [
      { value: 1, title: 'X > Max' },
      { value: 2, title: 'X < Min' },
      { value: 3, title: 'X < Min 或 X > Max' },
      { value: 4, title: 'Min < X < Max' },
      { value: 5, title: '开关 ON' },
      { value: 6, title: '开关 OFF' },
      { value: 7, title: '超过 Sec 秒, X > Max' },
      { value: 8, title: '超过 Sec 秒, X < Min' },
      { value: 9, title: '超过 Sec 秒, X < Min 或 X > Max' },
      { value: 10, title: '超过 Sec 秒, Min < X < Max' },
      { value: 11, title: '超过 Sec 秒, 开关 ON' },
      { value: 12, title: '超过 Sec 秒, 开关 OFF' },
      { value: 13, title: 'X > Max 告警, X < Min 解除' },
      { value: 14, title: 'X < Min 告警, X > Max 解除' },
      { value: 15, title: 'X = Value' }
    ]
  },
  mutations: {
    SET_DEVS: (state, devs) => {
      Vue.set(state, 'devsArr', devs)
    },
    SET_MAPPING: (state, mappings) => {
      Vue.set(state, 'mappingArr', mappings)
    },
    SET_ICON: (state, icons) => {
      Vue.set(state, 'iconsArr', icons)
    }
  },
  actions: {
    // 获取所有模型摘要信息
    getAllDevAction({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.devsArr.length > 0) {
          resolve(state.devsArr)
        }
        getAllDevApi().then(res => {
          if (res.errno === 0 && res.data) {
            commit('SET_DEVS', res.data)
            resolve(res.data)
          } else {
            reject([])
          }
        }).catch(err => {
          console.log(err)
          reject([])
        })
      })
    },
    getAllMappingAction({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.mappingsArr.length > 0) {
          resolve(state.mappingsArr)
        }
        getAllMappingApi().then(res => {
          if (!res.errno && res.data) {
            commit('SET_MAPPING', res.data)
            resolve(res.data)
          } else {
            reject([])
          }
        }).catch(err => {
          console.log(err)
          reject([])
        })
      })
    },
    getAllIconAction({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.iconsArr.length > 0) {
          resolve(state.iconsArr)
        }
        getAllIconApi().then(res => {
          if (res.errno === 0 && res.data.all) {
            commit('SET_ICON', res.data.all)
            resolve(res.data.all)
          } else {
            reject([])
          }
        }).catch(err => {
          console.log(err)
          reject([])
        })
      })
    }
  }
}

export default devStore
